"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var ContactModel = function ContactModel(json, lang) {
  var data = {};
  data.social_media = [];
  data.registration_numbers = [];
  data.mobile_phone = [];
  data.telephone = [];
  var has_website = false; // Contact ways

  if (json.length > 0) {
    json.forEach(function (contact_link) {
      var contact = contact_link;

      if (contact.medium.toUpperCase() === "WEBSITE") {
        has_website = true;
        contact.value && data.social_media.push({
          name: "Website",
          url: contact["value_".concat(lang)][6] || contact.value_nl[6] || contact.value_fr[6] || contact.value_de[6] || contact.value_en[6] === "/" ? contact["value_".concat(lang)] || contact.value_nl || contact.value_fr || contact.value_de || contact.value_en : "https://".concat(contact["value_".concat(lang)] || contact.value_nl || contact.value_fr || contact.value_de || contact.value_en),
          icon: "Website"
        }); // Set website on resultspage (WIP because this will always be the last website that loads in)

        if ((contact && contact["value_".concat(lang)][6]) === "/" || contact.value_nl[6] === "/" || contact.value_fr[6] === "/" || contact.value_de[6] === "/" || contact.value_en[6] === "/") {
          data.website = contact["value_".concat(lang)] || contact.value_nl || contact.value_fr || contact.value_de || contact.value_en;
        } else {
          data.website = contact["value_".concat(lang)] || contact.value_nl || contact.value_fr || contact.value_de || contact.value_en;
          data.website = 'https://' + data.website;
        }
      }

      if (contact.medium.toUpperCase() === "FAX") {
        if (contact["value_".concat(lang)] || contact.value_nl || contact.value_fr || contact.value_de || contact.value_en) {
          data.fax = contact["value_".concat(lang)] || contact.value_nl || contact.value_fr || contact.value_de || contact.value_en;
        }
      }

      if (contact.medium.toUpperCase() === "FIXED") {
        // if (contact.telephone_subtype === 'FIXED') { data.telephone = contact.telephone }
        if (data.telephone.length < 2) {
          data.telephone.push(contact["value_".concat(lang)] || contact.value_nl || contact.value_fr || contact.value_de || contact.value_en);
        }
      }

      if (contact.medium.toUpperCase() === "MOBILE") {
        if (data.mobile_phone.length < 2) {
          if (!data.mobile_phone.includes(contact.mobile_phone)) {
            data.mobile_phone.push(contact["value_".concat(lang)] || contact.value_nl || contact.value_fr || contact.value_de || contact.value_en);
          }
        }
      }

      if (contact.medium.toUpperCase() === "EMAIL") {
        data.social_media.push({
          email: contact.id,
          name: "Mail",
          icon: "Mail"
        });
      }

      if (contact.medium.toUpperCase() === "FACEBOOK") {
        console.log(value);
        data.social_media.push({
          name: "Facebook",
          url: contact["value_".concat(lang)][6] === "/" || contact.value_nl[6] === "/" || contact.value_fr[6] === "/" || contact.value_de[6] === "/" || contact.value_en[6] === "/" ? contact["value_".concat(lang)] || contact.value_nl || contact.value_fr || contact.value_de || contact.value_en : "https://".concat(contact["value_".concat(lang)] || contact.value_nl || contact.value_fr || contact.value_de || contact.value_en),
          icon: "Facebook"
        });
      }

      if (contact.medium.toUpperCase() === "INSTAGRAM") {
        data.social_media.push({
          name: "Instagram",
          url: contact["value_".concat(lang)][6] || contact.value_nl[6] || contact.value_fr[6] || contact.value_de[6] || contact.value_en[6] === "/" ? contact["value_".concat(lang)] || contact.value_nl || contact.value_fr || contact.value_de || contact.value_en : "https://".concat(contact["value_".concat(lang)] || contact.value_nl || contact.value_fr || contact.value_de || contact.value_en),
          icon: "Instagram"
        });
      }

      if (contact.medium.toUpperCase() === "LINKEDIN") {
        data.social_media.push({
          name: "LinkedIn",
          url: contact["value_".concat(lang)][6] || contact.value_nl[6] || contact.value_fr[6] || contact.value_de[6] || contact.value_en[6] === "/" ? contact["value_".concat(lang)] || contact.value_nl || contact.value_fr || contact.value_de || contact.value_en : "https://".concat(contact["value_".concat(lang)] || contact.value_nl || contact.value_fr || contact.value_de || contact.value_en),
          icon: "Linkedin"
        });
      }

      if (contact.medium.toUpperCase() === "TWITTER") {
        data.social_media.push({
          name: "Twitter",
          url: contact["value_".concat(lang)][6] || contact.value_nl[6] || contact.value_fr[6] || contact.value_de[6] || contact.value_en[6] === "/" ? contact["value_".concat(lang)] || contact.value_nl || contact.value_fr || contact.value_de || contact.value_en : "https://".concat(contact["value_".concat(lang)] || contact.value_nl || contact.value_fr || contact.value_de || contact.value_en),
          icon: "Twitter"
        });
      }

      if (contact.medium.toUpperCase() === "PINTEREST") {
        data.social_media.push({
          name: "Pinterest",
          url: contact["value_".concat(lang)][6] || contact.value_nl[6] || contact.value_fr[6] || contact.value_de[6] || contact.value_en[6] === "/" ? contact["value_".concat(lang)] || contact.value_nl || contact.value_fr || contact.value_de || contact.value_en : "https://".concat(contact["value_".concat(lang)] || contact.value_nl || contact.value_fr || contact.value_de || contact.value_en),
          icon: "Pinterest"
        });
      }

      if (contact.medium.toUpperCase() === "YOUTUBE") {
        data.social_media.push({
          name: "YouTube",
          url: contact["value_".concat(lang)][6] || contact.value_nl[6] || contact.value_fr[6] || contact.value_de[6] || contact.value_en[6] === "/" ? contact["value_".concat(lang)] || contact.value_nl || contact.value_fr || contact.value_de || contact.value_en : "https://".concat(contact["value_".concat(lang)] || contact.value_nl || contact.value_fr || contact.value_de || contact.value_en),
          icon: "Youtube"
        });
      }

      if (contact.medium.toUpperCase() === "FLICKR") {
        data.social_media.push({
          name: "Flickr",
          url: contact["value_".concat(lang)][6] || contact.value_nl[6] || contact.value_fr[6] || contact.value_de[6] || contact.value_en[6] === "/" ? contact["value_".concat(lang)] || contact.value_nl || contact.value_fr || contact.value_de || contact.value_en : "https://".concat(contact["value_".concat(lang)] || contact.value_nl || contact.value_fr || contact.value_de || contact.value_en),
          icon: "Flickr"
        });
      }

      if (contact.medium.toUpperCase() === "WHATSAPP") {
        data.social_media.push({
          name: "WhatsApp",
          url: contact["value_".concat(lang)][6] || contact.value_nl[6] || contact.value_fr[6] || contact.value_de[6] || contact.value_en[6] === "/" ? contact["value_".concat(lang)] || contact.value_nl || contact.value_fr || contact.value_de || contact.value_en : "https://".concat(contact["value_".concat(lang)] || contact.value_nl || contact.value_fr || contact.value_de || contact.value_en),
          icon: "Whatsapp"
        });
      }

      if (contact.medium.toUpperCase() === "WEBSHOP") {
        data.social_media.push({
          name: "Webshop",
          url: contact["value_".concat(lang)][6] || contact.value_nl[6] || contact.value_fr[6] || contact.value_de[6] || contact.value_en[6] === "/" ? contact["value_".concat(lang)] || contact.value_nl || contact.value_fr || contact.value_de || contact.value_en : "https://".concat(contact["value_".concat(lang)] || contact.value_nl || contact.value_fr || contact.value_de || contact.value_en),
          icon: "Eshop"
        });
      }

      if (contact.medium.toUpperCase() === "NEWSLETTER") {
        contact.newsletter && data.social_media.push({
          name: "Newsletter",
          url: contact["value_".concat(lang)][6] || contact.value_nl[6] || contact.value_fr[6] || contact.value_de[6] || contact.value_en[6] === "/" ? contact["value_".concat(lang)] || contact.value_nl || contact.value_fr || contact.value_de || contact.value_en : "https://".concat(contact["value_".concat(lang)] || contact.value_nl || contact.value_fr || contact.value_de || contact.value_en),
          icon: "Newsletter"
        });
      }
    });
  } // Function that gives unique values in an array (example Delhaize --> multiple social media's if not used)


  var uniq = function uniq(a) {
    var seen = {};
    return a.filter(function (item) {
      // With an exception for website
      if (item.name === "Website") {
        // return true
        // for website check on url instead of name
        return seen.hasOwnProperty(item.url) ? false : seen[item.url] = true;
      } // filter out the duplicate items and return the uniques.
      else {
          return seen.hasOwnProperty(item.name) ? false : seen[item.name] = true;
        } // return seen.hasOwnProperty(item.name) ? false : (seen[item.name] = true);

    });
  };

  var uniqValues = uniq(data.social_media);
  data.social_media = uniqValues; // Sort the social media icons based on this priority list

  var priority = ["Mail", "Website", "Newsletter", "E-shop", "Webshop", "Facebook", "Instagram", "WhatsApp", "YouTube", "Pinterest", "LinkedIn", "Twitter", "Flickr"];
  var sorted_socialMedia = data.social_media.sort(function (a, b) {
    if (priority.indexOf(a.name) > priority.indexOf(b.name)) return 1;
    if (priority.indexOf(a.name) < priority.indexOf(b.name)) return -1;
    return 0;
  });
  data.social_media = sorted_socialMedia;
  return data;
};

var _default = ContactModel;
exports["default"] = _default;